import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TranslateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Translate",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16.67 19.77c-.19 0-.36-.03-.53-.1-2.21-.72-4-1.66-5.66-2.96-.24-.2-.45-.36-.63-.52-.21.18-.41.34-.63.51-1.64 1.25-3.32 2.14-5.59 2.98-.16.05-.31.08-.46.08-.51 0-.91-.29-1.09-.78a1.2 1.2 0 0 1-.08-.41c0-.46.3-.88.8-1.07 1.51-.51 3.33-1.24 5.39-2.85.02-.02.04-.03.05-.04-1.38-1.6-2.42-3.52-3.1-5.74H2.95c-.55 0-.93-.46-.93-1.11s.38-1.05.93-1.05h5.69V5.09c0-.59.48-1.03 1.14-1.03s1.15.43 1.15 1.03v1.62h5.97c.54 0 .93.45.93 1.05s-.39 1.11-.93 1.11h-2.3c-.68 2.21-1.74 4.14-3.15 5.74.16.13.32.25.48.37 1.38 1 3.16 1.89 5.04 2.48.5.16.81.57.81 1.06 0 .14-.03.29-.09.43-.23.72-.8.8-1.04.8h.02ZM7.46 8.88c.53 1.5 1.35 2.93 2.4 4.17 1.05-1.23 1.86-2.67 2.35-4.17zm21.5 19.05c-.22 0-.42-.06-.62-.21-.18-.14-.31-.32-.41-.55l-1.34-3.15h-6.83l-1.32 3.15c-.1.25-.23.44-.41.56-.16.13-.38.2-.6.2-.34 0-.59-.09-.76-.28-.16-.19-.23-.42-.23-.71 0-.13.02-.24.06-.36l5.67-13.68c.08-.25.22-.45.43-.58.18-.13.38-.19.6-.19.29 0 .5.06.7.21.2.13.34.31.43.55l5.59 13.49q.09.195.09.45c0 .33-.11.6-.33.79a1 1 0 0 1-.72.3h.02Zm-3.26-6.06-2.53-6.01-2.52 6.01z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M3.14 22.14a1.146 1.146 0 0 1-.3-2.25c4.7-1.3 8.59-5.98 9.46-11.39a1.144 1.144 0 1 1 2.26.36c-1.01 6.26-5.58 11.7-11.11 13.23-.1.03-.2.04-.31.04Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.57 22.14c-.13 0-.26-.02-.38-.07-3.6-1.28-6.33-3.61-8.59-7.34a1.14 1.14 0 0 1 .38-1.57 1.14 1.14 0 0 1 1.57.38c1.98 3.25 4.33 5.28 7.41 6.37.59.21.9.87.69 1.46-.17.47-.61.76-1.08.76ZM16.77 9.57H2a1.14 1.14 0 1 1 0-2.28h14.77a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.38 9.57c-.63 0-1.14-.51-1.14-1.14V5a1.14 1.14 0 1 1 2.28 0v3.43c0 .63-.51 1.14-1.14 1.14M30 27.86c-.46 0-.9-.28-1.07-.74L24 13.97l-4.93 13.15c-.22.59-.88.89-1.47.67s-.89-.88-.67-1.47l6-16c.17-.45.59-.74 1.07-.74s.9.3 1.07.74l6 16c.22.59-.08 1.25-.67 1.47-.13.05-.27.07-.4.07"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28 22.52h-8a1.14 1.14 0 1 1 0-2.28h8a1.14 1.14 0 1 1 0 2.28"
      })]
    })
  }));
};
TranslateIcon.displayName = 'TranslateIcon';